import { useMemo, type ReactNode } from 'react';
import { Flex, Select, theme, Typography } from 'antd';
import type { SelectProps } from 'antd/es/select';

type SelectValue = string | number;

interface SelectEchoProps extends Omit<SelectProps<SelectValue>, 'children'> {
  displayLabel?: ReactNode;
  children?: ReactNode;
}

const SelectEcho = ({ displayLabel, style, children, ...selectProps }: SelectEchoProps) => {
  const { token } = theme.useToken();

  const labelRender = useMemo(
    () =>
      displayLabel
        ? () => (
            <Typography.Text
              ellipsis
              style={{
                fontSize: token.fontSize,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {displayLabel}
            </Typography.Text>
          )
        : undefined,
    [displayLabel, token.fontSize]
  );

  return (
    <Flex vertical style={{ width: '100%', minWidth: 0 }}>
      <Select<SelectValue>
        {...selectProps}
        labelRender={labelRender}
        style={{
          fontSize: token.fontSize,
          cursor: 'pointer',
          width: '100%',
          minWidth: 0,
          ...style,
        }}
      >
        {children}
      </Select>
    </Flex>
  );
};

const SelectOption = Select.Option;

export { SelectEcho, SelectOption };
